import { putMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const UPDATE_LOCATION = 'UPDATE_LOCATION';
export const UPDATE_LOCATION_SUCCESS = 'UPDATE_LOCATION_SUCCESS';
export const UPDATE_LOCATION_FAILURE = 'UPDATE_LOCATION_FAILURE';

// Action Creators
export const updateLocation = () => ({
  type: UPDATE_LOCATION,
});

export const updateLocationSuccess = (data) => ({
  type: UPDATE_LOCATION_SUCCESS,
  payload: data,
});

export const updateLocationFailure = (error) => ({
  type: UPDATE_LOCATION_FAILURE,
  payload: error,
});

// Thunk Function
export const updateLocationCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(updateLocation());
    try {
      const response = await putMethodWithToken(
        url.staff + data?.enterpriseId + '/locations/' + data?.id + '/',
        data?.detail
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(updateLocationSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(updateLocationFailure(response?.data));
      }
    } catch (error) {
      dispatch(updateLocationFailure(error?.message));
    }
  };
};
